import { FunctionalComponent, h } from '@stencil/core';
import { href } from 'stencil-router-v2';
import get from 'lodash/get'

interface AppLightbox {
    data,
    className
}


export const AppLightbox: FunctionalComponent<AppLightbox> = ({ data, className }, children) => {

    if (!data) return children;
    const { Alt, Icon, Label, NewTab, URL } = data;
    const slug = get(data, 'page.data.attributes.Slug');
    const icon = Icon ? (<span class="uk-margin-small-right uk-icon" uk-icon={Icon}></span>) : '';
    const link = URL && URL.startsWith('http') ? { href: URL } : href(URL || '/' + slug)
    return (<a data-attrs="width: 1280; height: 720;" {...link} class={className} aria-label={Label || Icon || Alt} target={`${NewTab ? '_blank' : ''}`} rel={`${NewTab ? 'noopener noreferrer' : ''}`}>{children && children.length ? children : [icon, Label]}</a>);
};